'use client'

import { Typography } from '@mui/material'
import Grid from '@mui/material/Grid'

export default function TotalRow({ label, value }: any) {
	return (
		<>
			<Grid item xs={12} md={9}></Grid>
			<Grid item xs={6} md={1}>
				<Typography variant="h6">{label}</Typography>
			</Grid>
			<Grid item xs={6} md={2}>
				<Typography textAlign={'right'}>$ {value}</Typography>
			</Grid>
		</>
	)
}
